import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Data,
  Params,
  RouterState,
  UrlSegment,
} from '@angular/router';
type Snapshot = Pick<ActivatedRouteSnapshot, 'root'>;

export function getRoutePathFromRoot(snapshot?: ActivatedRouteSnapshot): string[] {
  if (!snapshot) {
    return [''];
  }
  return snapshot.pathFromRoot
    .map((route: ActivatedRouteSnapshot) => route.url)
    .flat()
    .filter(Boolean)
    .map((urlSegment: UrlSegment) => urlSegment.path)
    .reduce((paths: string[], path: string) => [...paths, `${paths.pop()}/${path}`], ['']);
}

export function getRouteUrl(snapshot?: ActivatedRouteSnapshot): string {
  if (!snapshot) {
    return '/';
  }
  const routePath: string = snapshot.pathFromRoot
    .map((route: ActivatedRouteSnapshot) => route.url)
    .flat()
    .filter(Boolean)
    .map((urlSegment: UrlSegment) => urlSegment.path)
    .join('/')
    .replace(/\/+/g, '/');

  return `/${routePath}`;
}

export function getActivatedRoutePath(snapshot: ActivatedRouteSnapshot): string {
  return (
    snapshot.pathFromRoot
      .map((route: ActivatedRouteSnapshot) => route.url)
      .flat()
      .filter(Boolean)
      .map((urlSegment: UrlSegment) => urlSegment.path)
      .pop() || ''
  );
}

export function getActivatedRoute(routerState: RouterState): ActivatedRoute {
  let route: ActivatedRoute = routerState.root;

  while (route.firstChild) {
    route = route.firstChild;
  }

  return route;
}

export function getRouteData(snapshot?: Snapshot): Data {
  if (!snapshot) {
    return {};
  }

  let data = { ...snapshot.root.data };
  let route: ActivatedRouteSnapshot | null = snapshot.root;

  while (route) {
    data = {
      ...data,
      ...route.data,
    };
    route = route.firstChild;
  }

  return data;
}

export function getRouteParams(snapshot?: Snapshot): Data {
  if (!snapshot) {
    return {};
  }

  let params: Params = { ...snapshot.root.params };
  let route: ActivatedRouteSnapshot | null = snapshot.root;

  while (route) {
    params = {
      ...params,
      ...route.params,
    };
    route = route.firstChild;
  }

  return params;
}
